import axios from 'axios'

export const actions = {
  async getFilesInfo(context: any, payload: any) {
    return axios
      .get(`/access_log`, payload)
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        console.error(error)
        return error
      })
  },
}
